import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        galleryModalContent: {
            bg: 'background.neutral.dark',
            backdropFilter: 'blur(15px)',
            color: 'foreground.neutral.inverse',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            w: '100%',
            maxW: '100vw',
            minH: '100vh',
            borderRadius: 0,
            p: 0,
            my: '0',
        },
        galleryModalHeader: {
            alignSelf: 'end',
            paddingTop: {base: remCalc(12), md: remCalc(24), lg: remCalc(40)},
            paddingBottom: {lg: remCalc(0)},
            paddingRight: {base: remCalc(12), md: remCalc(24), lg: remCalc(40)},
            layerStyle: {lg: 'full-width'},
            width: {lg: '100%'},
            margin: {lg: '0 auto'},
            display: {lg: 'flex'},
            justifyContent: {lg: 'end'},
        },
        galleryModalHeaderContent: {
            position: 'absolute',
            top: 0,
            right: {base: remCalc(12), md: remCalc(24), lg: remCalc(40)},
            zIndex: 1,
            height: {base: remCalc(36), md: remCalc(48), lg: remCalc(40)},
            width: remCalc(36),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        galleryModalCloseIcon: {
            color: 'foreground.neutral.inverse',
            boxSize: remCalc(16),
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        galleryModalBody: {
            alignContent: 'center',
            layerStyle: {lg: 'full-width'},
            width: {lg: '100%'},
            margin: {lg: '0 auto'},
            flex: 1,
            minH: 0,
            paddingTop: {base: remCalc(12), md: remCalc(24), lg: remCalc(40)},
            paddingBottom: {base: remCalc(12), md: remCalc(24), lg: remCalc(40)},
            px: remCalc(0),
        },
        dotsAndTabsContainer: {
            paddingBottom: {base: remCalc(12), md: remCalc(24), lg: remCalc(40)},
        },
    },
    parts: ['galleryModalContainer'],
}
